import React, { useState, useEffect } from 'react'
import { Link } from "gatsby";
import T from "../T/T";
import "./styles.scss";
import { LocaleLink } from "../../lib/IntlTools";
import { navigate } from 'gatsby-plugin-intl';

export default function CookiesMessage() {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      if (localStorage.getItem("cookieAccepted")) {
        setAccepted(true)
      }
    }
  }, []);

  const handleClick = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("cookieAccepted", "1");
      setAccepted(true)
    }
  };

  return (
    !accepted && (
      <div id="modal-cookies" className="uk-flex-top modal-cookies uk-modal uk-flex uk-open">
        <div className="uk-modal-dialog uk-margin-auto-vertical">
          <p>
            <T>cookie-modal-text</T>
            <Link to={LocaleLink("/privacy")}>
              <T>privacy-title</T>
            </Link>.
          </p>

          <div className={`cookies-modal-actions`}>
            <button className="button-light"
              onClick={() => navigate('/cookies')}
            >
              <T>cookie-modal-view-details</T>
            </button>
            <button className="button-dark"
              onClick={handleClick}
            >
              <T>cookie-modal-button</T>
            </button>
          </div>
        </div>
      </div>
    )
  )
}
